"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ListTable = _interopRequireDefault(require("01_core/components/layout/module/ListTable"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _react2 = require("@emotion/react");
var _CountsColumn = _interopRequireDefault(require("./kansaReportSummary/CountsColumn"));
var _CountsHeader = _interopRequireDefault(require("./kansaReportSummary/CountsHeader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 監査報告サマリ
 */
const KansaReportSummary = props => {
  const {
    intl,
    entries,
    openDetail
  } = props;
  const sumList = entries.hakkenjikoSumList;
  const headerHeight = 120;
  const rowHeight = 50;
  const rowNumUpper = 10;
  if (!sumList) {
    return null;
  }
  const onDetailClick = (target, hakkenjikoBunruiCd) => () => {
    openDetail(entries, target, hakkenjikoBunruiCd);
  };
  const columns = [{
    dataKey: 'counts',
    label: /*#__PURE__*/_react.default.createElement(_CountsHeader.default, null),
    width: 1000,
    flexGrow: 3
  }];
  const createRow = (data, index) => {
    let totalRow = index === sumList.length - 1;
    const counts = /*#__PURE__*/_react.default.createElement(_CountsColumn.default, {
      item: data,
      totalRow: totalRow,
      onLinkClick: onDetailClick
    });
    return {
      counts
    };
  };
  return /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_REPORT_SUMMARY
    })
  }, sumList && sumList.length > 0 ? /*#__PURE__*/_react.default.createElement(_react2.ClassNames, null, _ref => {
    let {
      css,
      theme
    } = _ref;
    const lastRowClassName = css({
      background: theme.palette.table && theme.palette.table.body && theme.palette.table.body.tertiary ? theme.palette.table.body.tertiary.main : undefined
    });
    return /*#__PURE__*/_react.default.createElement(_ListTable.default, {
      autoWidth: true,
      columns: columns,
      rowData: sumList,
      createRow: createRow,
      headerHeight: headerHeight,
      rowHeight: rowHeight,
      height: headerHeight + rowHeight * (sumList.length < rowNumUpper ? sumList.length : rowNumUpper),
      lastRowClassName: lastRowClassName
    });
  }) : /*#__PURE__*/_react.default.createElement(_Typography.default, null, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_REPORT_TARGET_JIGYO_NOT_FOUND
  })));
};
const mapStateToProps = state => {
  return {
    fixedConditions: state.pandeTotalize.fixedConditions
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactIntl.injectIntl)(KansaReportSummary));